export default "__VITE_ASSET__9MuVLq9G__"